/** Metrics — create form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { createMetricSchema, type CreateMetricInput } from "@aos/shared";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader } from "@/components/layout/PageHeader";
import {
  FormGrid,
  MarkdownField,
  TextField,
} from "../projects/_form";

/** MetricCreate (D6) — create form backed by `createMetricSchema`. */
export function MetricCreate() {
  const form = useForm<CreateMetricInput, any, CreateMetricInput>({
    resolver: zodResolver(createMetricSchema),
    defaultValues: {
      name: "",
      description: "",
      unit: "",
      owner_user_id: "",
    },
    refineCoreProps: { resource: "metrics", action: "create" },
  });

  const {
    refineCore: { formLoading },
    saveButtonProps,
    control,
  } = form;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader
        title="New metric"
        subtitle="Define a measurable signal — name it, give it a unit, and assign an owner."
        icon="okrs"
      />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Metric details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <FormGrid>
                <TextField
                  control={control}
                  name="name"
                  label="Name"
                  placeholder="Weekly active users"
                />
                <TextField
                  control={control}
                  name="unit"
                  label="Unit"
                  placeholder="%, $, count…"
                  description="How the metric is measured."
                />
              </FormGrid>
              <MarkdownField
                control={control}
                name="description"
                label="Description"
                placeholder="What this metric captures and how to read it."
              />
              <TextField
                control={control}
                name="owner_user_id"
                label="Owner"
                placeholder="user_…"
                description="The user accountable for this metric."
              />
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Creating…" : "Create metric"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default MetricCreate;
